module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
         name: "Filter",
         path: "database/filter",
         component: () => import('./filter/filter.vue'),
      },
      {
         name: "Schema",
         path: "schema/schema",
         component: () => import('./schema/schema.vue'),
      },
      {
         name: "Table",
         path: "table/table",
         component: () => import('./table/table.vue'),
      },
      {
         name: "Events",
         path: "table/events",
         component: () => import('./event/event.vue'),
      },
      {
         name: "Playground",
         path: "table/playground",
         component: () => import('./playground/playground.vue'),
      },
      {
         name: "Table_Field",
         path: "table/:table/fields",
         component: () => import('./field/field'),
      },
      {
         name: "EventStats",
         path: "table/events/stats",
         component: () => import('./event-stats/event-stats'),
      },
      {
         name: "TableMain",
         path: "database/table_main",
         component: () => import('./table_main/table_main.vue'),
      },
   ]
}